import { gql } from '@apollo/client';

export const CHANGE_TASK_STATUS_MUTATION = gql`
  mutation ChangeTaskStatus($input: ChangeTaskStatusInput!) {
    changeTaskStatus(input: $input) {
      task {
        id
        status
      }
    }
  }
`;
